import { getStore } from '../store/appModuleStore';

export const getOfflineSyncStatus = () => {
    const store = getStore();

    return store.offlineSyncStatus;
};
